<template>
  <div id="bottom-nav" class="bg-nav">
    <div>
      <Button absolute class="scan-button" @onClick="openScanner">
        <Icon icon="fluent:qr-code-28-filled" class="white--text txt-huge"></Icon>
      </Button>
    </div>

    <div class="menu-tabs">
      <div v-for="(item, i) in menus" :key="i" class="nav-menu-item" :class="{ 'active-menu': $route.name === item.to }"
        v-ripple @click="routeTo(item.to)">
        <div class="flex-center">
          <Icon :icon="item.icon" class="txt-m-large"></Icon>
        </div>
        <div class="txt-detail text-center">
          {{ item.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue2'
import Button from "./Button"
import { bottomNavMenus } from "../store/constants"


export default {
  name: "Footer",
  components: {
    Icon,
    Button,
  },
  data() {
    return {
      menus: bottomNavMenus
    }
  },
  methods: {
    openScanner() {
      this.$router.push({ name: "Scanner" })
    },
    routeTo(route) {
      if (!route || route === this.$route.name) return
      this.$router.push({ name: route })
    }
  }
}
</script>

<style scoped lang="scss">
.bg-nav {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: end;
  min-height: var(--footer-height);
  color: #fff;
}

.menu-tabs {
  width: 100%;
  min-height: calc(var(--footer-height) - calc(var(--scanner-btn-size) / 2));
  background: var(--footer-bg-color);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: var(--menu-tab-gap);
}

.nav-menu-item {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  flex-direction: column;
  gap: 8px;
  min-width: var(--nav-item-min-width);
  max-width: var(--nav-item-max-width);
  padding: 8px;
  cursor: pointer;
  white-space: nowrap;
}

.nav-menu-item:nth-child(3) {
  min-width: var(--nav-scanner-spacing);
  max-width: var(--nav-scanner-spacing);
  cursor: unset;
  pointer-events: none;
}

.nav-menu-item:not(:nth-child(3)):hover {
  background: rgba(255, 255, 255, 0.05);
}

.nav-menu-item:not(:nth-child(3)):hover,
.nav-menu-item:not(:nth-child(3)).active-menu {
  color: var(--theme-one);
}

.scan-button {
  bottom: calc(var(--footer-height) - var(--scanner-btn-size));
  left: calc(50% - calc(var(--scanner-btn-size) / 2));
  border-radius: 50%;
  min-width: var(--scanner-btn-size) !important;
  min-height: var(--scanner-btn-size) !important;
  max-width: var(--scanner-btn-size) !important;
  max-height: var(--scanner-btn-size) !important;
  padding: 0 !important;
  z-index: 50;
}

</style>